import {
	Component,
	HostBinding,
	OnInit,
	ChangeDetectorRef,
	Input
} from '@angular/core';

import { userAgentUtil } from 'vbrick-player-src/UserAgentUtil';
import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import { VideogularComponent } from '../Videogular.Component';

import styles from './VgVolume.module.less';
import { PLAYER_USER_PREFERENCE_KEY } from 'vbrick-player-src/shared/userPreference/PlayerUserPreferenceHandler';
import { PlayerUserPreferencesService } from 'vbrick-player-src/shared/userPreference/PlayerUserPreference.Service';

const CHANGE_PER_PRESS = 0.05;

@Component({
	selector: 'vg-volume',
	host: {
		'[class]': 'styles.root + " " + (isSmallSizePlayer ? styles.smallSizePlayer : "")'
	},
	template: `
		<vg-mute-button
			[currentVolume]="vgApi.volume"
			[vbrickPlayer]="vbrickPlayer">
		</vg-mute-button>

		<vg-volume-bar *vgControlDisplay="4"
			[translations]="translations"
			[isSmallSizePlayer]="isSmallSizePlayer">
		</vg-volume-bar>
	`
})
export class VgVolumeComponent implements OnInit {
	@Input() public translations: any;
	@Input() public isSmallSizePlayer: boolean;

	public readonly styles = styles;
	public isVolumeBarVisible: boolean;
	private mouseLeaveTimeoutRef: number;
	private _isEntered: boolean;

	constructor(
		public changeDetector: ChangeDetectorRef,
		public vbrickPlayer: VBrickPlayerComponent,
		public vgApi: VideogularComponent,
		private readonly PlayerUserPreferencesService: PlayerUserPreferencesService
	) {}

	public ngOnInit(): void {
		this.updateElementVisibilityClass(false);
	}

	public ngAfterViewInit(): void {
		const userPreferenceVolume = this.PlayerUserPreferencesService.getPreference<number>(PLAYER_USER_PREFERENCE_KEY.VOLUME);
		if (userPreferenceVolume != null) {
			this.vgApi.setVolume(userPreferenceVolume);
		}
	}

	public get isEntered(): boolean {
		return this._isEntered;
	}

	public updateElementVisibilityClass(isVisible: boolean): void {
		this.isVolumeBarVisible = isVisible;

		this.changeDetector.detectChanges();
	}

	@HostBinding('hidden')
	private get isComponentSurfaced(): boolean {
		return userAgentUtil.isMobile || userAgentUtil.isAndroidChrome;
	}

	public onVolumeAreaKeyDown(event: KeyboardEvent): void {
		const isUp = event.key === 'ArrowUp' ||  event.key === 'ArrowRight';
		const isDown = event.key === 'ArrowDown' || event.key === 'ArrowLeft';
		if (!isUp && !isDown) {
			return;
		}

		const currentVolume = this.vgApi.volume != null ?
			this.vgApi.volume :
			1;
		const newVolume = isUp ? Math.min(1, currentVolume + CHANGE_PER_PRESS)
			: Math.max(0, currentVolume - CHANGE_PER_PRESS);

		this.vgApi.setVolume(newVolume);
		this.storeVolumePreference();
		event.preventDefault();
	}

	public storeVolumePreference(): void {
		this.PlayerUserPreferencesService.setPreference<number>(PLAYER_USER_PREFERENCE_KEY.VOLUME, this.vgApi.volume);
	}
}
